export function getClientHeaders(): Record<string, string> {
  if (typeof window === "undefined") return {};

  const isDesktop = !!(window as any).electronAPI;
  return {
    "X-Client-App": "chat",
    "X-Client-Platform": isDesktop ? "desktop" : "web",
    "X-Client-Name": isDesktop ? "Meridian Desktop" : "Meridian Web",
    "X-Client-Version": isDesktop ? "desktop" : "web",
  };
}
